export default "__VITE_ASSET__DHi6H5_0__"